import {Component, DestroyRef, inject} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatFormField, MatLabel, MatError} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardContent} from '@angular/material/card';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TranslocoModule} from '@jsverse/transloco';
import {PasswordResetService} from '../../services/password-reset.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField, MatLabel, MatError, MatInput,
    MatButton,
    MatCard, MatCardContent,
    RouterLink,
    TranslocoModule,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
})
export class ForgotPasswordComponent {
  forgotForm: FormGroup;
  loading = false;
  submitted = false;
  protected clientId = '';

  private readonly passwordResetService = inject(PasswordResetService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.clientId = params['client_id'] || '';
      if (!this.clientId) {
        this.router.navigate(['/']);
      }
    });
    this.forgotForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  submit(): void {
    if (this.forgotForm.invalid || this.loading) {
      this.forgotForm.markAllAsTouched();
      return;
    }
    this.loading = true;
    const email = this.forgotForm.get('email')!.value.trim();
    // Anti-enumeration: show the same confirmation screen whether or not the
    // account exists, AND whether the backend succeeds or errors. The backend
    // already returns {status:"ok"} for unknown accounts; we additionally treat
    // transport errors as "submitted" so the UI never reveals account state.
    this.passwordResetService.requestReset(email, this.clientId).subscribe({
      next: () => {
        this.loading = false;
        this.submitted = true;
      },
      error: () => {
        this.loading = false;
        this.submitted = true;
      },
    });
  }
}
